import React from 'react';
import styles from './multiple-plot-list-legend.module.scss'
import { useTranslation } from 'react-i18next';

const MultiplePlotListLegend = () => {
    const { t } = useTranslation()
    return (
        <div className={styles.legend}>
            <span>{t('multiplePlotListLegend.title')}</span>
            <div className={styles.legendItems}>
                <div className={styles.legendItem}>
                    <div className={`${styles.colorBox} ${styles.initial}`}></div>
                    <span>{t('multiplePlotListLegend.initialPlot')}</span>
                </div>
                <div className={styles.legendItem}>
                    <div className={`${styles.colorBox} ${styles.plotsToMerge}`}></div>
                    <span>{t('multiplePlotListLegend.plotsToMerge')}</span>
                </div>
                <div className={styles.legendItem}>
                    <div className={`${styles.colorBox} ${styles.selectedPlot}`}></div>
                    <span>{t('multiplePlotListLegend.selectedPlot')}</span>
                </div>
                <div className={styles.legendItem}>
                    <div className={`${styles.colorBox} ${styles.filled}`}></div>
                    <span>{t('multiplePlotListLegend.filled')}</span>
                </div>
                <div className={styles.legendItem}>
                    <div className={`${styles.colorBox} ${styles.mergedBoundaries}`}><div className={styles.mergedBoundariesLine}></div></div>
                    <span>{t('multiplePlotListLegend.mergedBoundaries')}</span>
                </div>
            </div>
        </div>
    );
};

export default MultiplePlotListLegend;
